export const SUPPORT_PHONE_NUMBER = '1-888-427-1500';
